import type { RouteRecordRaw } from 'vue-router'
// import BuyMerch from './buy-merch'
import Community from './community'
import Events from './events'
import Game from './game'
import GeneralPost from './general-post'
import GlobalSearch from './global-search'
import News from './news'
import Ranking from './ranking'
import Support from './support'
import myMapleRoute from './my-maple'

const routes: RouteRecordRaw[] = [
  News,
  GeneralPost,
  Game,
  Ranking,
  Events,
  Community,
  Support,
  myMapleRoute,
  // Registered in every environment: visibility is decided at runtime by the `global-search`
  // exposure flag, which a build-time `isLive` check would make unreachable in live. The route
  // guard in `main.ts` turns a direct visit away while the flag is off.
  GlobalSearch,
]

export default routes
